<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Grupo
        </span>
      </h3>
    </div>
    <Form url="/produtos/create-grupo" :grupo="grupo" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import GrupoData from "./GrupoData";
import { mapGetters } from "vuex";

export default {
  name: "app-grupos-create",
  data() {
    return {
      grupo: new GrupoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
